import { Skeleton } from "@/components/ui/skeleton";

const WhyChooseUsSkeleton = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center gap-y-[10px]  xm:flex-row xm:gap-x-10">
        <Skeleton className="w-10 h-10 mx-auto rounded-full" />
        <div className="flex flex-col gap-4">
          <Skeleton className="w-[293px] h-11 text-center" />
          <Skeleton className="w-[293px] h-28 text-center" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-y-[10px] xm:flex-row xm:gap-x-10">
        <Skeleton className="w-10 h-10 mx-auto rounded-full" />
        <div className="flex flex-col gap-4">
          <Skeleton className="w-[293px] h-11 text-center" />
          <Skeleton className="w-[293px] h-28 text-center" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-y-[10px] xm:flex-row xm:gap-x-10">
        <Skeleton className="w-10 h-10 mx-auto rounded-full" />
        <div className="flex flex-col gap-4">
          <Skeleton className="w-[293px] h-11 text-center" />
          <Skeleton className="w-[293px] h-28 text-center" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-y-[10px] xm:flex-row xm:gap-x-10">
        <Skeleton className="w-10 h-10 mx-auto rounded-full" />
        <div className="flex flex-col gap-4">
          <Skeleton className="w-[293px] h-11 text-center" />
          <Skeleton className="w-[293px] h-28 text-center" />
        </div>
      </div>
    </>
  );
};

export default WhyChooseUsSkeleton;
